<template>
  <v-container fluid fill-height>
    <v-flex class="overlay"></v-flex>
    <v-layout align-content-center wrap>
      <v-flex xs12><v-icon color="warning">warning</v-icon></v-flex>
      <v-flex xs12><span class="display-4">401</span></v-flex>
      <v-flex xs12><span class="display-1">Unauthorized</span></v-flex>
      <v-flex xs12 mt-3><span class="title">(You dont have access to this content)</span></v-flex>
      <v-flex xs-12 mt-2><v-btn color="primary" @click="$router.push({ name: 'signIn' })"><v-icon left medium dark>keyboard_backspace</v-icon>Back</v-btn></v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "NotAuthorized",
  components: {},
  data() {
    return {

    };
  },
  methods: {}
};
</script>

<style scoped>

.layout {
  position: relative;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  opacity: .5;
}

.v-icon {
  font-size: 150px;
}

.display-4 {
  letter-spacing: 10px !important;
}

</style>
